/**
 * PortalModal — Bootstrap-free modal rendered via ReactDOM.createPortal.
 * Fixes the React 19 "removeChild" DOM reconciler crash caused by Bootstrap Modal.
 *
 * Props:
 *   show     – boolean
 *   onClose  – () => void
 *   title    – string (optional)
 *   size     – 'sm' | 'md' | 'lg' (default 'md')
 *   children – modal body content
 */
import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BsX } from 'react-icons/bs';

const WIDTHS = { sm: 380, md: 520, lg: 720 };

export default function PortalModal({ show, onClose, title, size = 'md', children }) {
  // Lock body scroll while open
  useEffect(() => {
    if (show) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  if (!show) return null;

  return ReactDOM.createPortal(
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 9990,
        }}
      />

      {/* Dialog */}
      <div
        role="dialog"
        aria-modal="true"
        style={{
          position: 'fixed',
          top: '50%', left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#fff',
          borderRadius: 8,
          width: WIDTHS[size] || WIDTHS.md,
          maxWidth: '95vw',
          maxHeight: '90vh',
          overflowY: 'auto',
          zIndex: 9991,
          boxShadow: '0 12px 40px rgba(0,0,0,0.22)',
        }}
      >
        {/* Header */}
        {title && (
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '16px 24px 12px',
            borderBottom: '1px solid #f0f0f0',
          }}>
            <h6 style={{ margin: 0, fontWeight: 700, fontSize: 15 }}>{title}</h6>
            {/* <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', display: 'flex', alignItems: 'center', padding: 2 }}>
              <BsX size={22} />
            </button> */}
          </div>
        )}

        {/* Body */}
        <div style={{ padding: 24 }}>
          {/* {!title && (
            <button onClick={onClose} style={{ position: 'absolute', top: 12, right: 16, background: 'none', border: 'none', cursor: 'pointer', color: '#888', display: 'flex', alignItems: 'center' }}>
              <BsX size={22} />
            </button>
          )} */}
          {children}
        </div>
      </div>
    </>,
    document.body
  );
}
